import { Routes } from '@angular/router';

export const BUSINESSUNIT_ROUTES: Routes = [
  {
    path: 'channels/business-units/view-edit/:businessUnitId',
    loadComponent: () =>
      import('./business-unit-view-edit/business-unit-view-edit.component').then(
        (com) => com.BusinessUnitViewEditComponent
      ),
    title: 'View/Edit Business Unit',
  },
  {
    path: 'channels/business-units/add',
    loadComponent: () =>
      import('./business-unit-add/business-unit-add.component').then(
        (com) => com.BusinessUnitAddComponent
      ),
    title: 'Add Business Unit',
  },
];
